export function isRtl():boolean{
  return document.dir === 'rtl'
}
